export default __webpack_public_path__ + "static/fk-0d7b8bda0baf2ed4f379c8a54683e909.svg";